import React from "react";
import { Inventory } from "./Inventory";

/* A group→process inventory scoped to ONE client group (LACN / CCCMG).
   The grid shows directly; the Reviewed / Issues sub-tabs live inside Inventory, below the search. */
export function GroupInventory({ user, sheet, group }) {
  return <Inventory key={`${group}-${sheet}`} user={user} sheet={sheet} initialGroup={group} lockGroup />;
}